export const NOTIFICATIONS_CONTAINER_COLORS = {
  RED: 'red',
  ORANGE: 'orange',
  PRIMARY_LIGHT_BLUE: 'primary-light-blue',
};
